var _excluded = ["align", "caps", "children", "className", "color", "dataSpacer", "id", "italic", "resetSpacing", "tag", "type", "uppercase", "weight"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
import { getCustomAttributes, getCustomClassNames } from "./text.utils";
export var TEXT_TYPES = {
  NORMAL: "normal",
  SMALL: "small",
  LABEL: "label",
  CAPTION: "caption",
  HEADING: "heading",
  HEADING_EXTRA: "heading-extra",
  HEADING_BIG: "heading-big",
  HEADING_SMALL: "heading-small",
  SUBHEAD: "subhead",
  SUBHEAD_SMALL: "subhead-small",
  MINOR: "minor",
  EDITO: "edito"
};
export var TEXT_COLORS = {
  BLACK: "black",
  WHITE: "white",
  GREY: "grey",
  GREY_LIGHT: "greyLight",
  MAIN_COLOR: "mainColor",
  SECOND_COLOR: "secondColor",
  SUCCESS: "success",
  WARNING: "warning",
  ERROR: "error"
};
export var TEXT_ALIGNS = {
  LEFT: "left",
  CENTER: "center",
  RIGHT: "right"
};
export var TEXT_WEIGHTS = {
  LIGHT: "light",
  NORMAL: "normal",
  MEDIUM: "medium",
  SEMI_BOLD: "semi-bold",
  BOLD: "bold",
  EXTRA_BOLD: "extra-bold",
  BLACK: "black"
};

/**
 * The types of the props that are used in the Text component
 */

// eslint-disable-next-line react/function-component-definition
export function Text(_ref) {
  var align = _ref.align,
    _ref$caps = _ref.caps,
    caps = _ref$caps === void 0 ? false : _ref$caps,
    children = _ref.children,
    className = _ref.className,
    color = _ref.color,
    dataSpacer = _ref.dataSpacer,
    id = _ref.id,
    _ref$italic = _ref.italic,
    italic = _ref$italic === void 0 ? false : _ref$italic,
    _ref$resetSpacing = _ref.resetSpacing,
    resetSpacing = _ref$resetSpacing === void 0 ? false : _ref$resetSpacing,
    tag = _ref.tag,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? TEXT_TYPES.NORMAL : _ref$type,
    _ref$uppercase = _ref.uppercase,
    uppercase = _ref$uppercase === void 0 ? false : _ref$uppercase,
    weight = _ref.weight,
    restProps = _objectWithoutProperties(_ref, _excluded);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var CustomTag = tag || "p";
  return /*#__PURE__*/React.createElement(CustomTag, _extends({}, getCustomAttributes({
    id: id,
    dataSpacer: dataSpacer
  }), {
    className: getCustomClassNames({
      type: type,
      color: color,
      align: align,
      caps: caps,
      italic: italic,
      uppercase: uppercase,
      className: className,
      weight: weight,
      resetSpacing: resetSpacing
    })
  }, restProps), children);
}